"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _validation = require("../../utils/validation");

var _fontSystem = require("../../utils/fontSystem");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  font-size: ", ";\n  line-height: ", ";\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  font-family: ", ";\n  text-align: ", ";\n  color: ", ";\n  font-weight: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var baseTextStyles = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.display;
}, function (props) {
  return props.fontFamily;
}, function (props) {
  return props.align;
}, function (props) {
  return props.color || 'inherit';
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom || (props.tag === 'p' ? '3rem' : 0);
}, function (props) {
  return props.truncate && "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ";
});

var StyledText = _styledComponents.default.span(_templateObject2(), _fontSystem.fontSystemStyles, baseTextStyles, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') && props.theme.typography.text[props.level].fontSize.xxs || '';
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') && props.theme.typography.text[props.level].lineHeight.xxs || '';
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.xs;
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') && props.theme.typography.text[props.level].fontSize.xs || '';
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') && props.theme.typography.text[props.level].lineHeight.xs || '';
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') && props.theme.typography.text[props.level].fontSize.sm || '';
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') && props.theme.typography.text[props.level].lineHeight.sm || '';
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.md;
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') && props.theme.typography.text[props.level].fontSize.md || '';
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') && props.theme.typography.text[props.level].lineHeight.md || '';
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.lg;
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') && props.theme.typography.text[props.level].fontSize.lg || '';
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') && props.theme.typography.text[props.level].lineHeight.lg || '';
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.xl;
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'fontSize') && props.theme.typography.text[props.level].fontSize.xl || '';
}, function (props) {
  return (0, _validation.nestedPropExists)(props.theme, 'typography', 'text', props.level, 'lineHeight') && props.theme.typography.text[props.level].lineHeight.xl || '';
});

exports.StyledText = StyledText;